/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React, { Suspense } from 'react';

import { jsx } from '@atlaskit/css';

const LazyRovoLoadingGif = React.lazy(
	() =>
		import(
			/* webpackChunkName: "@atlassian/conversation-assistant-ui-components/rovo-loading-gif" */ './main'
		),
);

/**
 * @deprecated please use LazyAnimatedRovoIcon from @atlassian/rovo-platform-ui-components/primitives/rovo-animated-icon/LazyAnimatedRovoIcon instead
 */
export const LazyAnimatedRovoIcon: React.MemoExoticComponent<({ alt, testId, width, height, }: {
    alt?: string;
    testId?: string;
    width?: string;
    height?: string;
}) => JSX.Element> = React.memo(
	({
		alt = '',
		testId = '',
		width = '',
		height = '',
	}: {
		alt?: string;
		testId?: string;
		width?: string;
		height?: string;
	}): JSX.Element => {
		return (
			<Suspense>
				<LazyRovoLoadingGif alt={alt} testId={testId} width={width} height={height} />
			</Suspense>
		);
	},
);
